import { authSign } from "@/api/active/active";
export const fxFn = async (wx) => {
  let data = {
    // timestamp: new Date().getTime(),
    url: window.location.href.split("#")[0],
  };
  const res = await authSign(data);
  wx.config({
    // debug: true,
    appId: "wx7cbd7ff9855f3660",
    timestamp: res.data.timestamp,
    signature: res.data.sign,
    nonceStr: res.data.nonceStr,
    jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 声明需要调用的接口
  });
  wx.error(() => {
    // Dialog({ message: "微信SDK初始化失败!" + JSON.stringify(res) });
  });
  // 3. 配置分享信息
  wx.ready(() => {
    // 分享给朋友
    wx.updateAppMessageShareData({
      title: "简阳市水务局“GlacierPreservation”（冰川保护）,",
      desc: "第33届“世界水日” 第38届“中国水周”（2025年3月22—28日）",
      link: "https://m.wtjy.com/#/wx/wxLogin", // 分享链接（默认当前页）
      // link: "https://m.wtjy.com", // 分享链接（默认当前页）
      imgUrl: "https://m.wtjy.com/fx.png?t=" + Date.now(),
    });

    // 分享到朋友圈

    wx.updateTimelineShareData({
      title: "简阳市水务局“GlacierPreservation”（冰川保护）", // 朋友圈默认不显示 desc
      link: "https://m.wtjy.com/#/wx/wxLogin",
      imgUrl: "https://m.wtjy.com/fx.png?t=" + Date.now(),
    });
  });
};
// 没登录就去登录
export const toLoginFn = () => {
  let wxOpenid = localStorage.getItem("wxOpenid");
  if (!wxOpenid) {
    window.location.href = "https://m.wtjy.com/#/wx/wxLogin";
    return true;
  }
  return false;
};

export const metaFn = () => {
  setMeta("og:title", "简阳市水务局“GlacierPreservation”（冰川保护）");
  setMeta(
    "og:description",
    "第33届“世界水日” 第38届“中国水周”（2025年3月22—28日）"
  );
  setMeta("og:image", "https://m.wtjy.com/fx.png");
};

function setMeta(property, content) {
  let meta = document.querySelector(`meta[property="${property}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("property", property);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}
